/* The row's actions: one line, never stacked. Tokens only (ADR-0007). */
.row {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  white-space: nowrap;
}

/* The one action the row draws: a small text button, the product's link colour, 24px tall. */
.main {
  height: 24px;
  padding: 0 8px;
  border: 0;
  border-radius: var(--radius-ctl);
  background: none;
  color: var(--accent);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}

.main:hover {
  background: var(--accent-w);
}

.main:focus-visible,
.more:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: -2px;
}

.more {
  display: inline-grid;
  place-items: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-ctl);
  background: none;
  color: var(--ink-2);
  cursor: pointer;
}

.more:hover,
.more[aria-expanded="true"] {
  background: var(--panel-3);
}
